import { Routes } from '@angular/router';
import { authGuard, authenticatedMatch, guestGuard } from './core/guards/auth.guard';
import { managerGuard } from './core/guards/manager.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login').then((m) => m.Login),
  },
  {
    path: 'signup',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/signup/signup').then((m) => m.Signup),
  },
  {
    path: 'manager',
    canActivate: [managerGuard],
    loadComponent: () =>
      import('./features/manager/manager-shell/manager-shell').then((m) => m.ManagerShell),
    loadChildren: () =>
      import('./features/manager/manager.routes').then((m) => m.managerRoutes),
  },
  {
    path: '',
    canMatch: [authenticatedMatch],
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/components/shell/shell').then((m) => m.Shell),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./features/patients/patients.routes').then(
            (m) => m.patientsRoutes
          ),
      },
      {
        path: 'appointments',
        loadChildren: () =>
          import('./features/appointments/appointments.routes').then((m) => m.appointmentsRoutes),
      },
      {
        path: 'emr',
        loadChildren: () =>
          import('./features/emr/emr.routes').then((m) => m.emrRoutes),
      },
      {
        path: 'settings',
        children: [
          { path: '', redirectTo: 'account', pathMatch: 'full' },
          {
            path: 'account',
            loadComponent: () =>
              import('./features/settings/account-settings').then((m) => m.AccountSettings),
          },
          {
            path: 'clinic',
            loadComponent: () =>
              import('./features/settings/clinic-settings').then((m) => m.ClinicSettings),
          },
          {
            path: 'staff',
            loadComponent: () =>
              import('./features/settings/staff-settings').then((m) => m.StaffSettings),
          },
        ],
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/landing/landing').then((m) => m.Landing),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
